import React from 'react';
import { Table, Badge, Text, ActionIcon, Tooltip } from '@mantine/core';
import { IconEdit } from '@tabler/icons-react';
import ConsentStatusBadge from './ConsentStatusBadge';
import { getAgeDivision } from '../../services/schoolService';

const FOOTWEAR = { pointe: 'Pointe', soft: 'Soft' };

/**
 * Review-step roster: each student with their solos and ensembles.
 * `students` come from /api/ensemble schoolReview.
 */
const ConfirmationTable = ({ students, onEditStudent }) => {
  if (students.length === 0) {
    return (
      <Text color="dimmed" ta="center" py="xl">
        No students registered yet.
      </Text>
    );
  }

  return (
    <div style={{ overflowX: 'auto' }}>
      <Table striped highlightOnHover withTableBorder withColumnBorders>
        <Table.Thead>
          <Table.Tr>
            <Table.Th>Student</Table.Th>
            <Table.Th>Solos</Table.Th>
            <Table.Th>Ensembles</Table.Th>
            <Table.Th>Parent Consent</Table.Th>
            {onEditStudent && <Table.Th>Edit</Table.Th>}
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody>
          {students.map((student) => {
            const division = student.dateOfBirth ? getAgeDivision(student.dateOfBirth) : null;
            const noEntries = !student.solos.length && !student.ensembles.length;
            return (
              <Table.Tr
                key={student.registrationId}
                style={{ cursor: onEditStudent ? 'pointer' : 'default' }}
                onClick={() => onEditStudent && onEditStudent(student.registrationId)}
              >
                <Table.Td>
                  <Text fw={500}>{student.name}</Text>
                  {division && <Badge variant="light" color="gold" size="sm" mt={4}>{division}</Badge>}
                </Table.Td>
                <Table.Td>
                  {student.solos.length ? student.solos.map((s) => (
                    <Text key={s.number} size="xs" color="var(--charcoal)" mb={2}>
                      {s.name || <span style={{ color: '#888' }}>Piece not chosen yet</span>}
                      {s.origin && <span style={{ color: '#888' }}> ({s.origin})</span>}
                      {' · '}
                      {s.footwear ? FOOTWEAR[s.footwear] : <span style={{ color: '#c92a2a' }}>footwear needed</span>}
                      {!s.hasMusic && <span style={{ color: '#888' }}> · no music yet</span>}
                    </Text>
                  )) : <Text size="xs" color="dimmed">—</Text>}
                </Table.Td>
                <Table.Td>
                  {student.ensembles.length
                    ? <Text size="xs">{student.ensembles.join(', ')}</Text>
                    : <Text size="xs" color="dimmed">—</Text>}
                  {noEntries && <Text size="xs" color="#c92a2a" fw={600}>No entries</Text>}
                </Table.Td>
                <Table.Td onClick={(e) => e.stopPropagation()}>
                  <ConsentStatusBadge status={student.consentStatus || 'not_required'} />
                </Table.Td>
                {onEditStudent && (
                  <Table.Td onClick={(e) => e.stopPropagation()}>
                    <Tooltip label="Edit student" withArrow>
                      <ActionIcon variant="subtle" color="gold" onClick={() => onEditStudent(student.registrationId)}>
                        <IconEdit size={16} />
                      </ActionIcon>
                    </Tooltip>
                  </Table.Td>
                )}
              </Table.Tr>
            );
          })}
        </Table.Tbody>
      </Table>
    </div>
  );
};

export default ConfirmationTable;
